export const TAG_VALUE_DROPDOWN_MAX_LENGTH = 15;
export const TAG_MAX_LENGTH = 50;
export const TAG_DASHBOARD_LENGTH = 10;
export const TAG_MENU_MAX_WIDTH = '200px';
export const TAG_COMP_MAX_WIDTH = '400px';
// as truncate would add +3 (symbolises 3 dots) char for length check
export const TAG_STR_MAX_LENGTH = 13;
